<script>
export default {
    name: 'ButtonNormal',
    props: {
        buttonTitle: {
            type: String,
            required: true,
        },
        cssClass: {
            type: String,
            required: true,
        }
    },
};
</script>

<template>
<button :class="cssClass" @click="$emit('onClick')">
    {{buttonTitle}}
</button>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/buttons.scss';
</style>
